'use client';

import classNames from 'classnames';
import { ReactNode } from 'react';

interface ModalFooterProps {
  className?: string;
  children: ReactNode;
  progressPercentage?: number;
}

const ModalFooter = ({ className, children, progressPercentage }: ModalFooterProps) => {
  return (
    <div
      className={classNames(
        'modal-action relative mt-0 h-[88px] justify-between border-t border-gray-200 p-6 dark:border-gray-700',
        className
      )}>
      {progressPercentage && (
        <div
          className={classNames('bg-primary absolute top-0 left-0 h-[3px]')}
          style={{
            width: `${progressPercentage}%`,
          }}
        />
      )}

      {children}
    </div>
  );
};

export default ModalFooter;
